<template>
  <form class="flex flex-col md:flex-row" @submit.prevent>
    <input
      type="text"
      aria-label="Email"
      spellcheck="false"
      placeholder="name@domain.com"
      :value="email"
      class="flex flex-1 form-input text-gray-900 text-sm py-3 md:rounded-r-none mb-2 md:mb-0"
      :class="{ 'input-error': invalid }"
      @input="$emit('input', $event.target.value.replace(/\s/g, ''))"
      @keydown.space.prevent
    />

    <button
      :disabled="disabled"
      class="relative flex justify-center bg-efpurple-9 hover:bg-efpurple-8 text-sm uppercase px-6 py-3 rounded md:rounded-l-none disabled:opacity-50 disabled:cursor-not-allowed"
      @click="$emit('click')"
    >
      <span
        class="transition-opacity duration-100"
        :class="{ 'opacity-0 transition-opacity duration-100': showLoader }"
      >
        Confirm
      </span>
      <div
        v-if="showLoader"
        class="loader absolute inset-0 m-auto rounded-full w-4 h-4 border-l-4 border-solid border-gray-900 animation-load animation-infinite animation-linear animation-0.5s"
      ></div>
    </button>
  </form>
</template>

<script>
export default {
  name: 'EmailInput',
  props: {
    email: {
      type: String,
      default: null
    },
    invalid: Boolean,
    disabled: Boolean,
    showLoader: Boolean
  }
};
</script>
